import styled from 'styled-components';
import { flexRowCSS, flexColCSS } from '../styled';

export const StyledSummary = styled.div`
  min-height: 60px;
  margin: 10px;
  height: 65px;
  width: 90%;
  position: relative;
  ${flexRowCSS}
`;

export const MetricDivider = styled.div`
    width: 1px;
    background: #979797;
    opacity: 0.5;
    padding-bottom: 1px;
    height: 80%;
    margin-right: 10px;
`;

export const MetricTileWrapper = styled.div`
    ${flexColCSS},
    background-color: #ffffff;
    height: 55px;
    width: 110px;
    align-items: flex-start;
    padding: 2.5px 0px;
    background-color: ${({ selected }: { selected: any }) => selected ? '#E9F3FD' : '#ffffff' };
    &:hover { background: #E9F3FD; }
    margin: 2.5px 0px;
`;

export const MetricNameWrapper = styled.div`
  flex-grow: 1;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  text-align: left;
`;

export const MetricValueWrapper = styled.div`
  flex-grow: 1;
  ${flexRowCSS};
  align-items: center;
  text-align: left;
`;

export const MetricValue = styled.div`
  font-size: 16px;
  line-height: 33px;
  font-weight: 600;
`;

export const MetricUnit = styled.div`
  font-weight: 300;
  padding-left: 2px;
`;

export const ErrorMessage = styled.div`
  color: #C32828;
  padding: 0 5px;
  text-align: center;
  width: 100%;
`;
